<template>
  <div class="sub-title mt-[28px] mb-[10px]">{{ $t('space.refund_policy') }}</div>
  <ul class="rule-ul">
    <li v-for="text in cancellationString">
      {{ text }}
    </li>
  </ul>
</template>
<script setup
        lang="ts">

import {computed} from "vue";
const {t} = useI18n();

const refundPolicyModelValue = defineModel('refundPolicy', { type: Object, default: () => ({}) });

/*const cancellationString = computed(() => {
  /!*新的退款政策
 嚴格政策 refund_policy_details.length === 0
 一般政策 refund_policy_details.length 最多
 寬鬆政策  *!/
  const policy = refundPolicyModelValue.value;
  const detailsLength = policy.refund_policy_details.length
  let details = JSON.parse(JSON.stringify(policy.refund_policy_details));

  if (policy.refund_policy_details.length > 0) {

    if (details.length > 0) {
      // 找到最後一個元素
      let lastItem = details[details.length - 1];


        // 創建新的物件
        let newItem = {
          "id": details.length + 1, // 新的id為該政策詳細長度 + 1
          "days_before": lastItem.days_before - 1, // 前一筆的 days_before - 1
          "percent": 0 // 固定為 0
        };

        // 新增到政策詳細中
        details.push(newItem);


      // 最後退款可以退款要擺最後，為了確保最後可以退款按鈕的判斷是拿到正確的日期
      details.sort((a, b) => b.days_before - a.days_before);


    }


  }


  const policyDescriptions = {
    // 嚴格政策
    0: () => [t('space.refund_policy_content_5')],

    // 其他政策
    1: () => details.map((detail, index) => {

      if (detail.percent === 0) {
        // 特殊情況，百分比為 0 時
        return t('space.refund_policy_normal_cancel_2', {d: detail.days_before})
      } else {
        // 一般情況
        return t('space.refund_policy_normal_cancel', {
          d: detail.days_before,
          p: detail.percent,
          h: index === 0 ? t('space.after_deducting_handling_fee') : ''
        })
      }
    })
  }
  return policyDescriptions[detailsLength > 0 ? 1 : 0]()


  /!* 不使用id當判斷
    const policyDescriptions = {
      1: () => [t('space.refund_policy_cant_cancel')],
      2: () => [
        t('space.refund_policy_easing_cancel', {
          d: policy.refund_policy_details[0].days_before,
          p: policy.refund_policy_details[0].percent
        })
      ],
      3: () => policy.refund_policy_details.map((detail, index) =>
          t('space.refund_policy_normal_cancel', {
            d: detail.days_before,
            p: detail.percent,
            h: index === 0 ? '扣除手續費 5% 後，' : ''
          })
      )
    }
    // 使用策略模式(Strategy Pattern)來選擇對應的描述
    return policyDescriptions[policy.id] ? policyDescriptions[policy.id]() : []*!/
})*/


const cancellationString = computed(() => {
  const policy = refundPolicyModelValue.value;
  let details = [...policy.refund_policy_details]; // 拷貝避免污染原始資料
  const hasDetails = details.length > 0;

  // 非嚴格政策：加入最後一筆百分比為0的說明
  if (hasDetails) {
    const lastItem = details[details.length - 1];
    const newItem = {
      id: details.length + 1,
      days_before: Math.max(lastItem.days_before - 1, 0),
      percent: 0,
    };
    details.push(newItem);
    details.sort((a, b) => b.days_before - a.days_before);
  }

  const getStrictPolicyDescription = () => [
    t('space.refund_policy_content_5'),
  ];

  const getNormalPolicyDescriptions = () =>
      details.map((detail, index) => {
        if (detail.percent === 0) {
          return t('space.refund_policy_normal_cancel_2', {
            d: detail.days_before,
          });
        }
        return t('space.refund_policy_normal_cancel', {
          d: detail.days_before,
          p: detail.percent,
          h: index === 0 ? t('space.after_deducting_handling_fee') : '',
        });
      });

  return hasDetails ? getNormalPolicyDescriptions() : getStrictPolicyDescription();
});

</script>
<style scoped
       lang="scss">
.rule-ul {
  @apply pl-[18px] list-disc;

  li {
    @apply text-[14px] text-osn-grey-00 mb-[10px];
  }
}
</style>
